import React, { useState, useEffect } from "react";

import styles from "./reaction-btns.module.scss";
import { useAppContext } from "@/context/appContext";
import updateUserActivity from "@/utils/update-user-activity";
import {
  BookMarkStarFillIcon,
  BookMarkStarIcon,
  SmallShareIcon,
} from "@/components/svgcomponents/common-icons";
import { useAuthStore } from "@/context/store";

export default function ReactionBtns({
  toolTipPosition = "top",
  handleBookmark,
  isLearningPath,
  isCourse,
  isLearningPathsDetail,
  isBookmarked,
}) {
  const { courseEntryUid, lessonEntryUid, courseDetail, setShareUrl } =
    useAppContext();
  const [bookmarked, setBookmarked] = useState(false);
  const { setPreviousPath } = useAuthStore();
  const [share, setShare] = useState("");
  const [loggedIn, setLoggedIn] = useState({});
  useEffect(() => {
    // let userData = getCookie("user");
    let userData = localStorage.getItem("user");
    let parsedData;
    if (userData) {
      parsedData = JSON.parse(userData);
      setLoggedIn(parsedData);
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setShare("");
    }, 5000);
  }, [share]);
  useEffect(() => {
    if (isLearningPathsDetail) {
      setBookmarked(isBookmarked);
    } else if (isLearningPath && isCourse) {
      setBookmarked(isBookmarked);
    } else {
      setBookmarked(
        courseDetail?.isCourse
          ? courseDetail?.courseData?.isBookmarked
          : courseDetail?.lessonData?.isBookmarked
      );
    }
  }, [
    courseDetail,
    isLearningPathsDetail,
    isLearningPath,
    isCourse,
    isBookmarked,
  ]);

  const handleClick = (btnType) => {
    if (btnType === "bookmark") {
      if (loggedIn && loggedIn?.email) {
        if (isLearningPathsDetail) {
          handleBookmark();
          setBookmarked(!bookmarked);
        } else {
          setBookmarked(!bookmarked);
          const data = {
            courseEntryUid: courseEntryUid,
            lessonEntryUid: lessonEntryUid,
            courseActivity: { isBookmarked: !bookmarked },
            lessonActivity: { isBookmarked: !bookmarked },
          };
          updateUserActivity(data);
        }
      } else {
        // setShowLoginModal(true);
        // router.push(window.location.pathname, "/login", { shallow: true });
        setPreviousPath(window.location.pathname);
        window.location.href = "/academy/login";
      }
    }

    if (btnType === "share") {
      const modal = document.getElementById("share-modal");
      if (modal) {
        const modalInstance = bootstrap.Modal.getOrCreateInstance(modal);
        modalInstance.show();
      }
      setShare(window.location.href);
      navigator.clipboard.writeText(window.location.toString());
      setShareUrl(window.location.toString());
    }
  };

  return (
    <div className="d-flex gap-4 m-0 p-0 align-items-center justify-content-between">
      <div
        className={`${
          loggedIn?.email
            ? `cs-tooltip cs-tooltip-${toolTipPosition} ms-1 acad-tooltip d-inline-block`
            : `cs-tooltip cs-tooltip-${toolTipPosition} d-inline-block ms-1 acad-tooltip disabled-checkbox`
        }`}
        data-tooltip={loggedIn?.email ? "Bookmark" : "Login to bookmark"}
        data-swiftype-index="false"
      >
        <div
          className={` outline-focussed ${styles["reaction-btn"]} ${
            bookmarked ? styles["bookmarked-fill"] : styles["bookmarked"]
          }`}
          onClick={() => handleClick("bookmark")}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              handleClick("bookmark");
            }
          }}
          role="button"
          tabIndex={0}
          data-swiftype-index="false"
          aria-label="Bookmark"
          aria-pressed={bookmarked}
        >
          {bookmarked ? <BookMarkStarFillIcon /> : <BookMarkStarIcon />}
          <span className="visually-hidden">
            {bookmarked ? "Remove bookmark" : "Add bookmark"}
          </span>
        </div>

        <div
          className="tooltip-caret"
          data-swiftype-index="false"
        ></div>
      </div>

      <div
        className={`cs-tooltip cs-tooltip-${toolTipPosition} ms-1 acad-tooltip d-inline-block`}
        data-tooltip={"Share"}
        data-swiftype-index="false"
      >
        <div
          className={
            "outline-focussed " +
            styles["reaction-btn"] +
            `${share.length > 0 ? ` ${styles["bookmarked"]}` : ""}`
          }
          onClick={(e) => handleClick("share")}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              handleClick("share");
            }
          }}
          role="button"
          tabIndex={0}
          aria-label="Share"
          data-bs-toggle="modal"
          data-bs-target="#share-modal"
          data-swiftype-index="false"
        >
          <SmallShareIcon />
          <div
            className="tooltip-caret"
            data-swiftype-index="false"
          ></div>
        </div>
      </div>
    </div>
  );
}
